import styled from "styled-components";

export const EmptyPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin-top: 2rem;
`;

export const Message = styled.h2`
  text-align: center;
  margin: 1rem;
`;

export const Image = styled.img`
  max-width: 50%;
  max-height: 50%;
`;